import EmberObject, { get } from "@ember/object"
import { inject as service } from "@ember/service"
import ENV from "../config/environment"

export default class SchoolYearAdapter extends EmberObject {
  @service
  ajax

  find(id) {
    return get(this, "ajax").requestFromAdapter(ENV.API_ROOT + "/school_years/" + id)
  }
}
